import React, { useState } from 'react';
import { useTaxDomiciles } from 'queries/taxDomiciles';
import { __ } from 'localisation';
import SimpleTable from 'modules/Tables/SimpleTable';
import LoadingBar from '@hubins/components/LoadingIndicators';
import Button, { ButtonWrap } from '@hubins/components/Button';
import EditTaxDomiciles from '@hubins/components/EditTaxDomiciles';
import countries from 'i18n-iso-countries';
import { getLanguage } from 'helpers/language';
import TaxDomicileHistory from '@hubins/components/TaxDomicileHistory';


const headers = [
  {
    Header: __('country'),
    accessor: 'country',
    Cell: ({ value }) => countries.getName(value, getLanguage()),
  },
  {
    Header: __('tin_number'),
    accessor: 'tin',
  },
];

const loadingObj = {
  country: <LoadingBar />,
  tin: <LoadingBar />,
};

const loadingState = [
  loadingObj,
]

const TaxDomiciles = ({ profileUuid, backofficeUser = false }) => {
  const [openModal, setOpenModal] = useState(false);
  const { data, isLoading, isFetched, refetch } = useTaxDomiciles(profileUuid);

  return (
    <>
      {openModal && (
        <EditTaxDomiciles profileUuid={profileUuid} countries={data?.data || []} setOpenModal={setOpenModal} refetch={refetch} />
      )}
      <SimpleTable
        headers={headers}
        data={isLoading || !isFetched ? loadingState : (data?.data || [])}
      />
      {(backofficeUser && isFetched && !isLoading) && (
        <ButtonWrap>
          <Button icon="pencil write 2" onClick={() => setOpenModal(true)}>
            {__('edit')}
          </Button>
          <TaxDomicileHistory profileUuid={profileUuid} />
        </ButtonWrap>
      )}
    </>
  );
};

export default TaxDomiciles;